(function() {
	'use strict';

	angular.module('in-out-rm')
		.controller('missingMembersCtrl',missingMembersCtrl);


	missingMembersCtrl.$inject = ['$scope','$rootScope','$filter'];
	function missingMembersCtrl($scope,$rootScope,$filter) {
		$scope.startSearchNow={};
		$scope.shortName={'shortName':$rootScope.app_data.data.short_name};
		// $scope.missingCount={'missingCount':$scope.totalMissing};
		$scope.searchInitialData = {
			fetchLost:1,
			categories: [{fields:['name',"yop",'has_duplicates'],displayName:$filter('asPortalLang')('Name',"Name")},{fields: ["institute", "yoj", "degree", "department","specialization"],displayName: $filter('asPortalLang')('Basic_Filters',"Basic Filters")}],
			lost: 1,
			fields: {
			has_duplicates: {
				displayName: "",
				actionString: "",
				hidden: true,
				futherSearchType: "dropdown",
				singleSearch: true,
				futherSearchParams: {
				    placeholder: "--"+$filter('asPortalLang')('Select_Option_Ph',"Select Option")+"--",
				    serviceNameField: "name",
				    serviceIdField: "id",
				    dropdownList: [{
                            id: 0,
                            name: $filter('asPortalLang')('Internship_Provider',"Internship Provider")
                        }, {
                            id: 1,
                            name: $filter('asPortalLang')('Internship_Referrer',"Internship Referrer")
                        }]
				},
				countsRequired: false
			}},
			dataParams: {has_duplicates:0}
		};

		activate();

		function activate() {
			setTimeout(function() {
				$scope.startSearchNow.start();
			}, 100);	
		}

	}

})();